import { createStyles } from '@material-ui/core';

export default (overrideClasses?: CSSObject) =>
  createStyles({
    title: {
      margin: '16px 0 8px',
    },
    ...overrideClasses,
  });
